import { createContext, useContext } from 'react';

export const UIContext = createContext({
  device: 'desktop'
});

export const useUIContext = () => useContext(UIContext);
